<template>
	<div class="header" :class="top>0?'active':''">
		<div class="flex align-items just-between menu cor-f w1200">
			<svgIcon iconClass="logo" class="logo" @click="home" v-if="windowWidth > 820"/>
			<svgIcon iconClass="" class="logo" @click="home" v-else/>
			<div class="flex align-items just-center menTab fs16"  v-if="windowWidth > 820">
				<div :class="i == menIdx?'active':''" v-for="(d,i) in menuTab" @click="subMenu(i)">
					<router-link :to="d.url" > {{d.name}}</router-link>
				</div>
			</div>
			<div class="phone flex align-items fs24 fw"  v-if="windowWidth > 820">
				<svgIcon iconClass="kefu" class="ico"/>
				400-0592-568
			</div>
			<img src="@/style/img/menu.png" @click="openMenu" class="more" alt="" srcset="" v-if="windowWidth <= 820">
			<div class="menuCont" :class="menuShow?'open':''" v-if="windowWidth <= 820">
				<div class="menuItem">
					<div class="up"><img src="@/style/img/up.png" alt="" @click="openMenu"></div>
					<div v-for="(d,i) in menuTab" :key="i" @click="goToUrl(d,i)">{{d.name}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import svgIcon from './plugins/svgIcon.vue'
	export default {
  components: { svgIcon },
		name: 'HeaDer',
		props: ['activeIdx'],
		data() {
			return{
				currentId:0,
				menuShow:false,
				windowWidth:'',
				menIdx:0,
				top:0,
				menuTab:[{
					name: '首页',
					url: '/'
				},{
					name: '走进五润',
					url: '/introduce'
				},{
					name: '集团业务',
					url: '/business'
				},{
					name: '集团生态',
					url: '/ecological'
				},{
					name: '新闻动态',
					url: '/news'
				},{
					name: '联系我们',
					url: '/kefu'
				}]
			}
		},
		watch: {
			windowWidth: {
				handler(e) {
				},
				immediate: true,
				deep: true
			},
			activeIdx(val){
				this.menIdx = val
				console.log(val,8989);
			}
		},
		beforeUpdate(){
			console.log(this.menIdx,'值');
		},
		mounted() {
			this.$bus.on("tabIdx",e =>{
				this.menIdx = e
				console.log(e,45454);
			});
			window.addEventListener('resize', () => this.windowWidth = window.innerWidth, false)
			window.addEventListener('mousewheel', this.debounce(this.handleScroll,300), true)||window.addEventListener("DOMMouseScroll",this.debounce(this.handleScroll,300),false)
			this.windowWidth = document.body.clientWidth
		},
		methods:{
		debounce(func, wait) {
				let timeout;
				return function () {
					let context = this;
					let args = arguments;
					if (timeout) clearTimeout(timeout);
					timeout = setTimeout(() => {
							func.apply(context, args)
					}, wait);
				}
			},
			handleScroll(e){
				this.top = document.documentElement.scrollTop || document.body.scrollTop
			},
			goToUrl(d,i){
				this.$router.push({
					path: d.url,
					query: {
						i
					}
				})
				this.menuShow = false
			},
			openMenu(){
				this.menuShow = !this.menuShow
				// this.$emit('getStudent',this.menuShow)
			},
			home(){
				this.$router.push('/')
				this.menIdx = 0
				localStorage.setItem('tabIdx',0)
			},
			subMenu(i){
				this.menIdx = i
				localStorage.setItem('tabIdx',i)
			}
		}
	}
</script>
<style scoped>
	@import url("../style/css_w/header.css");
	
</style>
